import React from 'react';

export const User: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.64991 3.01673C10.5611 3.92796 10.5611 5.40534 9.64991 6.31657C8.73868 7.22779 7.2613 7.22779 6.35008 6.31657C5.43885 5.40534 5.43885 3.92796 6.35008 3.01673C7.2613 2.10551 8.73868 2.10551 9.64991 3.01673"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66666 12.3333V13C2.66666 13.368 2.96532 13.6666 3.33332 13.6666H12.6667C13.0347 13.6666 13.3333 13.368 13.3333 13V12.3333C13.3333 10.316 10.6987 9.00531 7.99999 9.00531C5.30132 9.00531 2.66666 10.316 2.66666 12.3333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
